import { z } from "zod";
import { TFile } from "../base";

export const TRawCompanyBranding = z.object({
  isActive: z.boolean().optional(),
  darkTextColor: z.string().optional(),
  lightTextColor: z.string().optional(),
  primaryColor: z.string().optional(),
  primaryTextColor: z.string().optional(),
  secondaryColor: z.string().optional(),
  secondaryTextColor: z.string().optional(),
  secondaryInactiveTextColor: z.string().optional(),
  buttonColor: z.string().optional(),
  buttonHoverColor: z.string().optional(),
  buttonTextColor: z.string().optional(),
  chartColors: z.array(z.string()).optional(),
  logo: TFile.optional(),
});
export type IRawCompanyBranding = z.infer<typeof TRawCompanyBranding>;

export type IRawPropertyBranding = z.infer<typeof TRawPropertyBranding>;
export const TRawPropertyBranding = z.object({
  isActive: z.boolean().optional(),
  darkTextColor: z.string().optional(),
  lightTextColor: z.string().optional(),
  primaryColor: z.string().optional(),
  primaryTextColor: z.string().optional(),
  secondaryColor: z.string().optional(),
  secondaryTextColor: z.string().optional(),
  secondaryInactiveTextColor: z.string().optional(),
  buttonColor: z.string().optional(),
  buttonHoverColor: z.string().optional(),
  buttonTextColor: z.string().optional(),
  chartColors: z.array(z.string()).optional(),
  logo: TFile.optional(),
});

export const TApiBrandingResponse = z.object({
  data: z.array(
    z.object({
      companyID: z.string(),
      branding: TRawCompanyBranding,
    })
  ),
});
export type IApiBrandingResponse = z.infer<typeof TApiBrandingResponse>;
